import useWindowSize from './useWindowSize';

const useMobileView = (width: number): boolean => {
    const windowWidth = useWindowSize();

    return windowWidth < width;
};

export default useMobileView;
